import { useMemo } from "react";
import {
  DAY_LABELS,
  MONTH_LABELS,
  getDaysOfWeek,
  getMondayOfWeek,
  toDateStr,
} from "../../utils";
import NavControls from "./NavControls";
import SlotCard from "./SlotCard";

export default function WeekView({
  slots = [],
  currentDate,
  setCurrentDate,
  onCardClick,
  onRegisterClick,
  onCardDelete,
}) {
  const monday = getMondayOfWeek(currentDate);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const days = getDaysOfWeek(monday);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const weekRangeLabel = `${monday.getDate()} – ${sunday.getDate()} ${MONTH_LABELS[sunday.getMonth()]} ${sunday.getFullYear()}`;

  const goWeek = (dir) => {
    const d = new Date(currentDate);
    d.setDate(d.getDate() + dir * 7);
    setCurrentDate(d);
  };

  const activeDays = useMemo(() => {
    return days.filter((day) =>
      slots.some((s) => s.slot_date === toDateStr(day)),
    );
  }, [days, slots]);

  return (
    <div className="week-view">
      <NavControls
        label={weekRangeLabel}
        onPrev={() => goWeek(-1)}
        onNext={() => goWeek(1)}
      />

      {activeDays.length === 0 ? (
        <div className="week-empty">Aucun événement cette semaine</div>
      ) : (
        <div
          className="week-grid"
          style={{
            gridTemplateColumns: `repeat(${Math.min(activeDays.length, 4)}, 1fr)`,
          }}
        >
          {activeDays.map((day) => {
            const dateStr = toDateStr(day);
            const daySlots = slots
              .filter((s) => s.slot_date === dateStr)
              .sort((a, b) =>
                (a.start_time || "").localeCompare(b.start_time || ""),
              );

            const isToday = day.getTime() === today.getTime();
            const dayIndex = day.getDay() === 0 ? 6 : day.getDay() - 1;

            return (
              <div
                key={dateStr}
                className={["week-column", isToday && "today"]
                  .filter(Boolean)
                  .join(" ")}
              >
                <div className="week-column-header">
                  <div className="week-day-badge">
                    <span className="week-day-label">
                      {DAY_LABELS[dayIndex]} {day.getDate()}
                    </span>
                  </div>
                  <span className="week-day-count">
                    • {daySlots.length} événement
                    {daySlots.length !== 1 ? "s" : ""}
                  </span>
                </div>

                <div className="week-column-body">
                  {daySlots.map((slot) => (
                    <SlotCard
                      key={slot.id}
                      slot={slot}
                      compact={true}
                      onCardClick={onCardClick}
                      onRegisterClick={onRegisterClick}
                      onDeleteClick={onCardDelete}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
